import { Trans } from "react-i18next";import { cn } from "../../../lib/utils";
import { ui } from "../../../components/ui";
import { ScheduleModeToggle } from "./ScheduleModeToggle";
import { DayTypeSelector } from "./DayTypeSelector";
import { WeekRow } from "./WeekRow";
import { WEEK_NUMBERS } from "../constants/scheduleConfig";

/**
 * DayScheduleCard
 *
 * One card per day_of_week (Mon–Sun). Mirrors org_weekly_work_schedule:
 * - mode === "All"    -> single row applies to week_number = 'All'
 * - mode === "Custom" -> one row per week_number '1'..'5'
 *
 * Props:
 * - dayOfWeek: number (1=Mon ... 7=Sun)
 * - dayLabel: string ("Monday")
 * - mode: "All" | "Custom"
 * - onModeChange: (nextMode: "All" | "Custom") => void
 * - allWeeksType: "FULL_DAY" | "HALF_DAY" | "HOLIDAY"  (used when mode === "All")
 * - onAllWeeksTypeChange: (type: string) => void
 * - weekTypes: { [weekNumber: string]: "FULL_DAY" | "HALF_DAY" | "HOLIDAY" } (used when mode === "Custom")
 * - onWeekTypeChange: (weekNumber: string, type: string) => void
 */
export function DayScheduleCard({
  dayOfWeek,
  dayLabel,
  mode,
  onModeChange,
  allWeeksType,
  onAllWeeksTypeChange,
  weekTypes,
  onWeekTypeChange
}) {
  const isCustom = mode === "Custom";

  return (
    <div className={cn(ui.card, "overflow-hidden")}>
      <div className="px-5 sm:px-6 py-4 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-3">
          <span className="h-9 w-9 shrink-0 flex items-center justify-center rounded-full border border-[var(--color-text-border)] text-sm font-bold text-[var(--color-primary)]">
            {dayOfWeek}
          </span>
          <h3 className="text-base font-bold text-foreground">{dayLabel}</h3>
        </div>

        <ScheduleModeToggle mode={mode} onChange={onModeChange} />
      </div>

      <div className="border-t border-[var(--color-text-border)]/70 px-5 sm:px-6 py-4">
        {!isCustom ?
        <div className="flex items-center gap-3 flex-wrap">
            <span className="text-xs font-semibold text-[var(--color-text-secondary)] whitespace-nowrap">
              <Trans i18nKey="dateTime.allWeeks" />
            </span>
            <DayTypeSelector value={allWeeksType} onChange={onAllWeeksTypeChange} />
          </div> :

        <div className="flex flex-col gap-2.5">
            {WEEK_NUMBERS.map((weekNumber) =>
          <WeekRow
            key={weekNumber}
            weekNumber={weekNumber}
            value={weekTypes?.[weekNumber]}
            onChange={(type) => onWeekTypeChange(weekNumber, type)} />

          )}
          </div>
        }
      </div>
    </div>);

}
